import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { sideBarContentAdmin, sideBarContentEmployee, sideBarContentSuperAdmin } from "../helpers/sideBarContent";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getEmployeeProfile } from "../redux/actions/employeeActions";
import { getCountryData } from "../redux/actions/otherActions";


function SideBar() {
  const userRole = JSON.parse(sessionStorage.getItem("userDetails")) || {}
  const role = userRole?.user?.role?.toLowerCase() || userRole?.user?.type?.toLowerCase() || "guest";
  const sideBarContent = userRole?.user?.type?.toLowerCase() == "employee" ? sideBarContentEmployee : userRole?.user?.type?.toLowerCase() == "admin" ? sideBarContentAdmin : sideBarContentSuperAdmin
  // //console.log("services" ,userRole?.user?.services);
  const dispatch = useDispatch()
  const countries = useSelector((state) => state.data?.countries)
  const employeeId = sessionStorage.getItem("employeeId");

  const isInvoiceBuy = userRole?.user?.services?.some((item)=>{
    return item?.name?.toLowerCase() == "invoice"
  })||false

  // //console.log("isInvoiceBuy" ,isInvoiceBuy);
  
  useEffect(() => {
    if (employeeId ) {
      dispatch(getEmployeeProfile(employeeId))
    }
    if (countries?.length == 0) {
      dispatch(getCountryData())
    }
  }, []);

  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-logo">
        <a href="/" className="logo logo-normal">
          <img src="/assets/img/logoNew.png" alt="Logo" style={{ width: 200, height: 40 }} />
        </a>
        <a href="/" className="logo-small">
          <img src="/assets/img/logoNew.png" alt="Logo" />
        </a>
        <a href="/" className="dark-logo">
          <img src="/assets/img/logoNew.png" alt="Logo" />
        </a>
      </div>
      <div className="sidebar-inner slimscroll mt-3">
        <div id="sidebar-menu" className="sidebar-menu sv-sidebar-menu">
          <ul>
            <li className="menu-title">
              <span>{role || "Super Admin"}</span>
            </li>
            <li>
              <ul className="pb-3">
                {
                  sideBarContent?.filter((item)=>{
                    if( !isInvoiceBuy ){
                      return item?.title != "Billing"
                    }else{
                      return item
                    }
                  })?.map((item, index) => {
                    if (item?.subMenu?.length > 0) {
                      return (
                        <li key={index} className={`submenu ${item?.paths?.includes(window.location.pathname) ? "active" : ""}  `}>
                          <Link to={item?.pathname || "#"} className={`${item?.paths?.includes(window.location.pathname) ? "active " : ""}`} data-discover="true">
                            <i className="ti ti-box"></i><span>{item?.title}</span>
                            <span className="menu-arrow">
                            </span>
                          </Link>
                          <ul style={{ display: item?.paths?.includes(window.location.pathname) ? "block" : "none" }}>
                            {
                              item?.subMenu?.map((subLink, indexN) => {
                                return (
                                  <li key={indexN} className="">
                                    <Link style={{ background: "transparent" }} className={`  ${item?.pathname == window.location.pathname ? "active" : ""}  `} to={subLink?.pathname} data-discover="true">
                                      {subLink?.title}
                                      <span className=""></span>
                                    </Link>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        </li>
                      )
                    }
                    return (
                      <li key={index} className={`submenu ${item?.pathname == window.location.pathname ? "active" : ""}  `}>
                        <Link to={item?.pathname}>
                          <i className={item?.iconName}></i>
                          <span>{item?.title}</span>
                        </Link>
                      </li>
                    )
                  })
                }

                {
                  role == "superadmin" &&
                  <li className={`submenu   `}
                  onClick={()=>{
                    localStorage.clear()
                    sessionStorage.clear()
                    setTimeout(() => {
                     window.location = "/login" 
                    }, 1000);

                  }} 
                  >
                    <Link href="#">
                    <i className="ti ti-logout"></i>
                    <span>Log Out</span>
                    </Link>
                  </li>
                }

              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default React.memo(SideBar) ;
